module.exports = __webpack_public_path__ + "static/media/erdbupdate.233b2dd3.svg";